import React, { useEffect, useState } from "react";
import {
  ADD_APPOINTMENT,
  API_BASE_URL,
  directToken,
  DOCTOR_LIST,
  GET_BOOKLIST,
  LIST_OF_AREA,
  LIST_OF_CITY,
  LIST_OF_HOSPITAL,
  LIST_OF_MASTER_SPECIALITY,
} from "../services/end_points";
import { Alert, Button, Col, Form, Input, Row, Select, Typography } from "antd";
import axios from "axios";
import { _post } from "../services/service_api";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const AddAppoinments = ({ data, updateUserList }) => {
  const [datesSlots, setDateSlots] = useState([]);
  const [filteredSlots, setFilteredSlots] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [timeSlots, setTimeSlots] = useState([]);
  const [intervals, setIntervals] = useState([]);
  const [fromTime, setFromTime] = useState([]);
  const [toTime, setToTime] = useState([]);
  const [result, setResult] = useState([]);
  const [chek, setCheck] = useState();
  const [doctorOption, setDoctorOption] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [selectedArea, setSelectedArea] = useState([]);
  const [selectedHospital, setSelectedHospital] = useState([]);
  const [filterCity, setFilterCity] = useState([]);
  const [filterAreas, setFilterAreas] = useState([]);
  const [selectedSpeciality, setSelectedSpeciality] = useState([]);
  const [filterHospitals, setFilterHospitals] = useState([]);
  const [filterSpeciality, setFilterSpeciality] = useState([]);
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [error, setError] = useState(["", ""]); // Initially empty error messages

  const userId = localStorage.getItem("userid");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    age: "",
    city: "",
    area: "",
    hospitalName: "",
    doctorName: "",
    doctorSpeciality: "",
    appTime: "",
    apptDate: "",
  });

  const [disabledSlots, setDisabledSlots] = useState([]);

  useEffect(() => {
    if (data && Array.isArray(data)) {
      const formattedData = data.map((item) => ({
        date: item.date,
        time: item.time || "",
        doctorId: item.doctorId || "",
        doctorName: item.doctorName || "",
        doctorSpeciality: item.doctorSpeciality || "",
      }));

      setDisabledSlots(formattedData);
    }
  }, []);

  useEffect(() => {
    getSpeciality();
    getArea();
    getCity();
    getHospital();
    getDoctor();
  }, []);

  useEffect(() => {
    generateTimeSlots();
  }, [datesSlots, fromTime, toTime, intervals]);
  const fetchSlotsList = async (doctorId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}${GET_BOOKLIST}${doctorId}`
      );
      if (response.data) {
        const slotsData = response.data;
        const parseDateString = (dateString) => {
          return new Date(
            dateString.replace(/(\w{3}) (\d{2}) (\w{3}) (\d{4})/, "$2 $3, $4")
          );
        };
        const today = new Date();
        const todayDate = new Date(
          today.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
        );
        const filteredSlots = slotsData.filter(
          (slot) => parseDateString(slot.date) >= todayDate
        );
        setResult(filteredSlots);
        setDateSlots(filteredSlots.map((slot) => slot.date));
        setIntervals(filteredSlots.map((slot) => slot.interval));
        setFromTime(filteredSlots.map((slot) => slot.fromTime));
        setToTime(filteredSlots.map((slot) => slot.toTime));
      } else {
        console.error("Error fetching the data");
      }
    } catch (error) {
      console.error("Error fetching the data:", error);
    }
  };

  const generateTimeSlots = () => {
    if (
      !fromTime.length ||
      !toTime.length ||
      !intervals.length ||
      !datesSlots.length
    ) {
      console.error(
        "fromTime, toTime, intervals, or datesSlots array is empty"
      );
      return;
    }

    const slots = [];
    // Helper function to convert 12-hour time format with AM/PM to 24-hour format
    const convertToMinutes = (time) => {
      const [timePart, period] = time.split(" ");
      let [hours, minutes] = timePart.split(":").map(Number);

      // Convert to 24-hour format
      if (period === "PM" && hours !== 12) {
        hours += 12;
      }
      if (period === "AM" && hours === 12) {
        hours = 0;
      }

      return hours * 60 + minutes; // Return total minutes since midnight
    };

    datesSlots.forEach((date, index) => {
      const start = fromTime[index];
      const end = toTime[index];
      const range = intervals[index];

      const startTime = convertToMinutes(start);
      const endTime = convertToMinutes(end);

      if (isNaN(startTime) || isNaN(endTime)) {
        console.error(`Error parsing start or end times for date ${date}`);
        return;
      }

      for (let i = startTime; i < endTime; i += parseInt(range)) {
        let hours = Math.floor(i / 60);
        let minutes = i % 60;
        let formattedStartTime = `${hours % 12 || 12}:${
          minutes < 10 ? "0" : ""
        }${minutes} ${hours >= 12 ? "PM" : "AM"}`;

        let nextTime = i + parseInt(range);
        hours = Math.floor(nextTime / 60);
        minutes = nextTime % 60;
        let formattedEndTime = `${hours % 12 || 12}:${
          minutes < 10 ? "0" : ""
        }${minutes} ${hours >= 12 ? "PM" : "AM"}`;

        slots.push({
          date: date,
          start: formattedStartTime,
          end: formattedEndTime,
        });
      }
    });

    setTimeSlots(slots);
  };

  const fridayTimeSlots = timeSlots.filter((slot) => slot.date === chek);

  const splitIntoRows = (slots, slotsPerRow) => {
    const rows = [];
    for (let i = 0; i < slots.length; i += slotsPerRow) {
      rows.push(slots.slice(i, i + slotsPerRow));
    }
    return rows;
  };
  const [currentDatePage, setCurrentDatePage] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const slotsPerRow = 4;
  const rowsPerPage = 4;
  const datesPerRow = 4;
  const rowsPerDatePage = 1;
  const dateRows = splitIntoRows(datesSlots, datesPerRow);
  const totalDatePages = Math.ceil(dateRows.length / rowsPerDatePage);
  const currentDates = dateRows.slice(
    currentDatePage * rowsPerDatePage,
    (currentDatePage + 1) * rowsPerDatePage
  );

  const handleNextDatePage = () => {
    if (currentDatePage < totalDatePages - 1) {
      setCurrentDatePage(currentDatePage + 1);
    }
  };

  const handlePreviousDatePage = () => {
    if (currentDatePage > 0) {
      setCurrentDatePage(currentDatePage - 1);
    }
  };
  const rows = splitIntoRows(fridayTimeSlots, slotsPerRow);
  const totalPages = Math.ceil(rows.length / rowsPerPage);
  const currentRows = rows.slice(
    currentPage * rowsPerPage,
    (currentPage + 1) * rowsPerPage
  );

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const getDoctor = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(`${API_BASE_URL}${DOCTOR_LIST}${userId}`, {
        headers,
      });
      const data = await response.json();
      setDoctorOption(
        data.list.map((source) => ({
          label: source.doctorsName,
          value: source.id,
        }))
      );
      setSelectedDoctor(data.list);
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };

  const getSpeciality = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(
        `${API_BASE_URL}${LIST_OF_MASTER_SPECIALITY}`,
        { headers }
      );
      const data = await response.json();
      setSelectedSpeciality(data.list);
    } catch (error) {
      console.error("Error fetching specialities:", error);
    }
  };

  const getArea = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(`${API_BASE_URL}${LIST_OF_AREA}`, {
        headers,
      });

      // Check if the response is okay before parsing
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      const data = await response.json();
      setSelectedArea(data.list);
    } catch (error) {
      console.error("Error fetching areas:", error);
    }
  };

  const getCity = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(`${API_BASE_URL}${LIST_OF_CITY}`, {
        headers,
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      setSelectedCity(data.list);
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const getHospital = async () => {
    try {
      const headers = {
        "authentication-token": `${directToken}`, // Ensure the token is prefixed with "Bearer" or whatever is required
      };
      const response = await fetch(
        `${API_BASE_URL}${LIST_OF_HOSPITAL}/${userId}`,
        { headers }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      setSelectedHospital(data.list);
    } catch (error) {
      console.error("Error fetching hospitals:", error);
    }
  };

  const handleDateChange = (date) => {
    setCheck(date);
    setFormData((prevData) => ({
      ...prevData,
      apptDate: date,
    }));
  };

  const handleTimeChange = (slot) => {
    setSelectedTime(slot);
    setFormData((prevData) => ({
      ...prevData,
      appTime: slot.start,
      apptDate: slot.date,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await _post(
        `${API_BASE_URL}${ADD_APPOINTMENT}`,
        formData,
        directToken
      );
      // updateUserList(res.data);
      // generateTimeSlots();
      setFormData({
        name: "",
        email: "",
        phone: "",
        age: "",
        city: "",
        area: "",
        hospitalName: "",
        doctorName: "",
        doctorSpeciality: "",
        appTime: "",
        apptDate: "",
      });
      setShow(false);
      setDayShow(false);
      setError("");
      if (res.status == 201) {
        setAlert({ type: "success", message: "Appointment Created!" });
        window.location.reload();
      } else if (res.status == 400) {
        setAlert({
          type: "failure",
          message: "Please fill in all required fields",
        });
      } else if (res.status == 404) {
        setAlert({ type: "failure", message: "Appointment Not Created!!" });
      }
    } catch (error) {
      if (error.response) {
        console.error("Server responded with status:", error.response.status);
        setAlert({ type: "failer", message: "Appointment Not Created!" });
        console.error("Response data:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
    }
  };

  const handleReset = () => {
    setFormData({
      name: "",
      email: "",
      age: "",
      city: "",
      area: "",
      hospitalName: "",
      doctorName: "",
      doctorSpeciality: "",
      apptDate: "",
    });
    setShow(false);
    setDayShow(false);
  };

  const handleInputValues = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));

    // if (name === "email") {
    //   const emailRegex = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;
    //   setError({
    //     ...error,
    //     emailError: emailRegex.test(value)
    //       ? ""
    //       : "Please enter a valid Gmail address",
    //   });
    // } else if (name === "phone") {
    //   const mobileRegex = /^\d{10}$/;
    //   setError({
    //     ...error,
    //     phoneError: mobileRegex.test(value)
    //       ? ""
    //       : "Please enter a valid 10-digit mobile number.",
    //   });
    // }
    if (name === "email") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;
      setError((prevState) => [
        emailRegex.test(value) ? "" : "Please enter a valid Gmail address",
        prevState[1], // Preserve the phoneError
      ]);
    } else if (name === "phone") {
      const mobileRegex = /^\d{10}$/;
      setError((prevState) => [
        prevState[0], // Preserve the emailError
        mobileRegex.test(value) ? "" : "Please enter a valid  mobile number.",
      ]);
    }
  };
  const [show, setShow] = useState(false);
  const [dayShow, setDayShow] = useState(true);

  const handleChanges = () => {
    setShow(!show);
  };

  const isSlotDisabled = (slot) => {
    return disabledSlots.some(
      (disabledSlot) =>
        disabledSlot.date === slot.date &&
        disabledSlot.time === slot.start &&
        disabledSlot.doctorId === formData.doctorName &&
        disabledSlot.specialityId === formData.specialityId
    );
  };
  return (
    <>
      <div>
        <div>
          {alert.message && (
            <div marginBottom="20px">
              <Alert
                style={{
                  backgroundColor:
                    // alert.type === "success" ? "#009f70e6" : "#f44336",
                    alert.type === "success" ? "#dff0d8" : "#f44336",
                  color: "green",
                  fontSize: "16px",
                  borderColor: alert.type === "success" ? "#dff0d8" : "#f44336",
                  textAlign: "center",
                }}
                message={alert.message}
              />
            </div>
          )}
        </div>
        <Form layout="vertical">
          <Row style={{ gap: "10px" }}>
            <Col xl={8} lg={8} md={11} sm={24} xs={24}>
              <Form.Item label="Name" required>
                <Input
                  style={{ height: "40px" }}
                  id="Name"
                  name="name"
                  value={formData.name}
                  onChange={(e) => handleInputValues("name", e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col xl={8} lg={8} md={11} sm={24} xs={24}>
              <Form.Item label="Email" required>
                <Input
                  style={{ width: "100%", height: "40px" }}
                  required
                  id="Email"
                  value={formData.email}
                  type="email"
                  name="email"
                  onChange={(e) => handleInputValues("email", e.target.value)}
                />
              </Form.Item>
              {error[0] && (
                <p style={{ color: "red", fontSize: "12px" }}>{error[0]}</p>
              )}
            </Col>
            <Col xl={7} lg={7} md={11} sm={24} xs={24}>
              <Form.Item label="Phone" required>
                <Input
                  style={{ width: "100%", height: "40px" }}
                  required
                  id="Phone"
                  name="phone"
                  maxLength="10"
                  value={formData.phone}
                  onChange={(e) => handleInputValues("phone", e.target.value)}
                />
              </Form.Item>
              {error[1] && (
                <p style={{ color: "red", fontSize: "12px" }}>{error[1]}</p>
              )}
            </Col>
            <Col xl={8} lg={7} md={11} sm={24} xs={24}>
              <Form.Item label="Age" required>
                <Input
                  style={{ width: "100%", height: "40px" }}
                  required
                  id="age"
                  name="age"
                  value={formData.age}
                  onChange={(e) => handleInputValues("age", e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col xl={8} lg={8} md={11} sm={24} xs={24}>
              <Form.Item label="Select Doctor" required>
                <Select
                  showSearch
                  style={{
                    width: "100%",
                    height: "40px",
                  }}
                  name="doctorName"
                  value={formData.doctorName || undefined}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  dropdownStyle={{ maxHeight: "100%", overflowY: "auto" }}
                  onChange={(value) => {
                    handleInputValues("doctorName", value);
                    const filteredValue = selectedDoctor.find(
                      (doctor) => doctor.id === value
                    );
                    if (filteredValue) {
                      const {
                        cityName,
                        areaName,
                        hospitalName,
                        specialityName,
                        cityId,
                        areaId,
                        hospitalId,
                        specialityId,
                      } = filteredValue;
                      handleInputValues("city", cityId);
                      handleInputValues("area", areaId);
                      handleInputValues("hospitalName", hospitalId);
                      handleInputValues("doctorSpeciality", specialityId);
                      setFilterCity([{ label: cityName, value: cityId }]);
                      setFilterAreas([{ label: areaName, value: areaId }]);
                      setFilterHospitals([
                        { label: hospitalName, value: hospitalId },
                      ]);
                      setFilterSpeciality([
                        { label: specialityName, value: specialityId },
                      ]);
                      fetchSlotsList(value);
                    }
                  }}
                  options={doctorOption}
                />
              </Form.Item>
            </Col>
            <Col xl={7} lg={8} md={11} sm={24} xs={24}>
              <Form.Item label="Select City" required>
                <Select
                  showSearch
                  style={{
                    width: "100%",
                    height: "40px",
                  }}
                  name="city"
                  value={formData.city || undefined}
                  onChange={(value) => {
                    handleInputValues("city", value);
                  }}
                  options={filterCity}
                />
              </Form.Item>
            </Col>
            <Col xl={8} lg={7} md={11} sm={24} xs={24}>
              <Form.Item label="Select Area" required>
                <Select
                  showSearch
                  style={{
                    width: "100%",
                    height: "40px",
                  }}
                  name="area"
                  value={formData.area || undefined}
                  onChange={(value) => {
                    handleInputValues("area", value);
                  }}
                  options={filterAreas}
                />
              </Form.Item>
            </Col>
            <Col xl={8} lg={8} md={11} sm={24} xs={24}>
              <Form.Item label="Select Hospital" required>
                <Select
                  showSearch
                  style={{
                    width: "100%",
                    height: "40px",
                  }}
                  name="hospitalName"
                  value={formData.hospitalName || undefined}
                  onChange={(value) => {
                    handleInputValues("hospitalName", value);
                  }}
                  options={filterHospitals}
                />
              </Form.Item>
            </Col>
            <Col xl={7} lg={8} md={11} sm={24} xs={24}>
              <Form.Item label="Select Speciality" required>
                <Select
                  showSearch
                  style={{
                    width: "100%",
                    height: "40px",
                  }}
                  name="doctorSpeciality"
                  value={formData.doctorSpeciality || undefined}
                  onChange={(value) => {
                    handleInputValues("doctorSpeciality", value);
                  }}
                  options={filterSpeciality}
                />
              </Form.Item>
            </Col>
          </Row>
          <hr style={{ marginTop: "20px", borderTop: "1px solid #ccc" }} />{" "}
          <div>
            {dayShow ? (
              datesSlots.length > 0 ? (
                <div style={{ marginRight: "16px" }}>
                  <Typography.Text>Schedule Dates</Typography.Text>
                  {currentDates.length > 0 ? (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        {/* Left Arrow Button */}
                        <Button
                          onClick={handlePreviousDatePage}
                          disabled={currentDatePage === 0}
                          icon={<LeftOutlined />}
                        />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            justifyContent: "center",
                          }}
                        >
                          {currentDates.map((row, rowIndex) => (
                            <div
                              key={rowIndex}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                flexWrap: "wrap",
                              }}
                            >
                              {row.map((date, index) => (
                                <Button
                                  size="small"
                                  key={index}
                                  onClick={() => {
                                    handleChanges();
                                    handleDateChange(date);
                                  }}
                                  style={{
                                    marginTop: "15px",

                                    margin: "5px",
                                    height: "60px",
                                    width: "100%",
                                    maxWidth: "120px",
                                    fontSize: "14px",
                                    border: "1px solid #0899f9",
                                    borderRadius: "11px",
                                    backgroundColor:
                                      formData.apptDate === date
                                        ? "#0899f9"
                                        : "#ffffff",
                                    color:
                                      formData.apptDate === date
                                        ? "#ffffff"
                                        : "#0899f9",
                                  }}
                                >
                                  {date}
                                </Button>
                              ))}
                            </div>
                          ))}
                        </div>

                        {/* Right Arrow Button */}
                        <Button
                          onClick={handleNextDatePage}
                          disabled={currentDatePage === totalDatePages - 1}
                          icon={<RightOutlined />}
                        />
                      </div>
                    </div>
                  ) : (
                    <Typography.Text>No available dates</Typography.Text>
                  )}
                </div>
              ) : (
                <Typography.Text>No available slots</Typography.Text>
              )
            ) : (
              <Typography.Text>
                Select a day to see available slots
              </Typography.Text>
            )}

            {/* Time Slot Section */}
            {show && (
              <div>
                <Typography.Text>Time Slots</Typography.Text>
                {currentRows.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* Left Arrow Button for Time Slots */}
                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 0}
                        icon={<LeftOutlined />}
                      />

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flexGrow: 1,
                          justifyContent: "center",
                        }}
                      >
                        {currentRows.map((row, rowIndex) => (
                          <div
                            key={rowIndex}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            {row.map((slot, index) => (
                              <Button
                                size="small"
                                key={index}
                                disabled={isSlotDisabled(slot)}
                                onClick={() => handleTimeChange(slot)}
                                style={{
                                  border: "1px solid #0899f9",
                                  borderRadius: "11px",
                                  height: "30px",
                                  margin: "5px",
                                  background: isSlotDisabled(slot)
                                    ? "#f0f0f0"
                                    : selectedTime &&
                                      selectedTime.start === slot.start
                                    ? "#1677ffd1"
                                    : "#ffffff",
                                  color:
                                    selectedTime &&
                                    selectedTime.start === slot.start
                                      ? "#ffffff"
                                      : "#0899f9",
                                  fontSize: "13px",
                                  width: "130px",
                                }}
                              >
                                {`${slot.start} - ${slot.end}`}
                              </Button>
                            ))}
                          </div>
                        ))}
                      </div>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages - 1}
                        icon={<RightOutlined />}
                      />
                    </div>
                  </div>
                ) : (
                  <Typography.Text>No available time slots</Typography.Text>
                )}
              </div>
            )}
          </div>
          <Row gutter={[12, 12]} style={{ justifyContent: "space-between" }}>
            <Col
              xl={6}
              md={6}
              style={{ display: "flex", justifyContent: "flex-start" }}
            >
              <Button
                type="button"
                onClick={handleReset}
                style={{
                  color: "black",
                  border: "solid #1236fa",
                  width: "100px",
                  height: "30px",
                  borderRadius: "3vw",
                }}
              >
                Reset
              </Button>
            </Col>
            <Col
              xl={6}
              md={6}
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button
                type="submit"
                onClick={handleSubmit}
                style={{
                  color: "white",
                  background: "#1236fa",
                  width: "100px",
                  height: "30px",
                  borderRadius: "3vw",
                }}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};
export default AddAppoinments;
